export var toKebabCase = function toKebabCase(value) {
  if (!value) {
    return '';
  }
  return value.split(/\.?(?=[A-Z])/).join('-').toLowerCase();
};